// extracted by mini-css-extract-plugin
module.exports = {"select_paper":"ConfirmationEmailModalContent_select_paper__HWOyA"};